<!-- <div class="outer-div">
  <img src="../../../../assets/Images/Loader/light.gif" />
</div>
 -->
<div class="preloader">
  <img src="assets/Images/Logo/logo-loading.gif" alt="" />
</div>
